<template>
  <v-main>
    <v-container
      class="mx-auto mt-6"
      style="max-width: 1200px;"
    >
      <v-img :src="imageData"></v-img>
    </v-container>
  </v-main>
</template>
<script>
import { defineComponent, computed } from 'vue';
import { Logger } from 'aws-amplify';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router'

const logger = new Logger('CovidCertificate');

export default defineComponent({
  setup() {
    logger.info('CovidCertificate');

    const store = useStore();
    const base64Data = store.getters['covidCertificate/covidCertificateImageData'];
    const router = useRouter();

    if (base64Data === '') {
      router.push('/error');
    }
    const imageData = computed(() => {
      return `data:image/jpeg;base64,${base64Data}`;
    })

    return {
      imageData
    }
  }
})
</script>
